/**
 * Достаёт объект результата yandexImageSearch из ответа subtask_update.
 */
export function extractYandexImageSearchPayload(raw) {
  if (raw == null || typeof raw !== 'object') return null;
  if (Array.isArray(raw)) return null;
  const hasKeys =
    Object.prototype.hasOwnProperty.call(raw, 'originalImage') ||
    Object.prototype.hasOwnProperty.call(raw, 'yandexUrls') ||
    Object.prototype.hasOwnProperty.call(raw, 'yandexSearch') ||
    Object.prototype.hasOwnProperty.call(raw, 'similarities');
  if (hasKeys) return raw;
  if (raw.result != null && typeof raw.result === 'object' && !Array.isArray(raw.result)) {
    return extractYandexImageSearchPayload(raw.result);
  }
  return null;
}

/**
 * Массив выдачи в subtask_update / get_requests может приходить в разной форме.
 */
export function extractSearchResultList(payload, depth = 0) {
  if (payload == null || depth > 4) return null;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.objects)) return payload.objects;
  if (Array.isArray(payload.result)) return payload.result;
  if (payload.result && Array.isArray(payload.result.result)) return payload.result.result;
  if (Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload.items)) return payload.items;
  if (Array.isArray(payload.results)) return payload.results;
  if (payload.result && typeof payload.result === 'object' && !Array.isArray(payload.result)) {
    const nested = extractSearchResultList(payload.result, depth + 1);
    if (nested) return nested;
  }
  return null;
}
